import { Controller } from "@hotwired/stimulus"
import { errorDetail, sendJSON } from "../api.js"

// Weryfikacja telefonu (SMS): request kodu -> wpisanie 6 cyfr -> confirm.
// Kod NIGDY nie jest w odpowiedzi API (idzie SMS-em). 429 = cooldown backendu
// (60 s / 10 dziennie) — przycisk "Wyślij ponownie" ma też lokalny odliczany cooldown.
export default class extends Controller {
  static targets = ["step1", "step2", "success", "message", "phoneInput", "codeInput", "requestBtn", "resendBtn"]
  static values = {
    requestUrl: String, // POST /api/phone/request/ {phone}
    confirmUrl: String, // POST /api/phone/confirm/ {code}
    next: String,       // ?next= zwalidowany przez serwer (np. koszyk); pusty = zostajemy na stronie
  }

  static COOLDOWN_SECONDS = 60
  static RETURN_DELAY_MS = 1500 // tyle widać komunikat „Numer potwierdzony”, zanim wrócimy na ?next=

  disconnect() {
    this.#stopCooldown()
    clearTimeout(this.returnTimer)
  }

  async request(event) {
    const phone = this.phoneInputTarget.value.trim()
    if (!phone) {
      this.#message("Podaj numer telefonu (format +48…).")
      return
    }
    const btn = event.currentTarget
    btn.disabled = true
    const res = await sendJSON("POST", this.requestUrlValue, { phone })
    if (!res.ok) {
      btn.disabled = false
      this.#message(errorDetail(res.data, res.status === 429
        ? "Zbyt wiele żądań kodu. Spróbuj później."
        : "Nie udało się wysłać kodu."))
      return
    }
    this.#message(null)
    this.step1Target.hidden = true
    this.step2Target.hidden = false
    if (this.hasCodeInputTarget) this.codeInputTarget.focus()
    this.#startCooldown()
  }

  async confirm() {
    const code = this.codeInputTarget.value.trim()
    if (!/^\d{6}$/.test(code)) {
      this.#message("Kod ma dokładnie 6 cyfr.")
      return
    }
    const res = await sendJSON("POST", this.confirmUrlValue, { code })
    if (!res.ok) {
      this.#message(errorDetail(res.data, "Kod niepoprawny lub wygasły."))
      return
    }
    this.#message(null)
    this.#stopCooldown()
    this.step2Target.hidden = true
    if (this.hasSuccessTarget) this.successTarget.hidden = false
    this.#returnToNext()
  }

  // Szew testowy: jedyne miejsce, gdzie kontroler opuszcza stronę (jsdom nie implementuje location.assign).
  navigate(url) {
    window.location.assign(url)
  }

  // --- prywatne ---

  // Po potwierdzeniu wracamy tam, skąd przyszedł kupujący (koszyk). Tylko ścieżka względna tego hosta.
  #returnToNext() {
    const target = this.nextValue
    if (!target || !target.startsWith("/") || target.startsWith("//")) return
    this.returnTimer = setTimeout(() => this.navigate(target), this.constructor.RETURN_DELAY_MS)
  }

  #startCooldown() {
    if (!this.hasResendBtnTarget) return
    this.#stopCooldown()
    let left = this.constructor.COOLDOWN_SECONDS
    const btn = this.resendBtnTarget
    btn.disabled = true
    btn.textContent = `Wyślij ponownie (${left} s)`
    this.cooldownTimer = setInterval(() => {
      left -= 1
      if (left <= 0) {
        this.#stopCooldown()
        btn.disabled = false
        btn.textContent = "Wyślij ponownie"
        return
      }
      btn.textContent = `Wyślij ponownie (${left} s)`
    }, 1000)
  }

  #stopCooldown() {
    if (this.cooldownTimer) {
      clearInterval(this.cooldownTimer)
      this.cooldownTimer = null
    }
  }

  #message(text) {
    if (!this.hasMessageTarget) return
    this.messageTarget.hidden = text === null
    if (text !== null) this.messageTarget.textContent = text
  }
}
